import { useCallback, useEffect, useState } from "react";
import {
  listScenarios, createScenario, updateScenario, deleteScenario, regenerateScenarios,
} from "@services/agentSim";

export function useAgentSimScenarios() {
  const [clinicId, setClinicId] = useState("");
  const [purpose, setPurpose] = useState("");
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const clearError = () => setError(null);

  const refresh = useCallback(async () => {
    if (!clinicId || !purpose) { setScenarios([]); return; }
    setLoading(true);
    try {
      const res = await listScenarios({ clinicId, purpose });
      setScenarios(res?.data || []);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  }, [clinicId, purpose]);

  // Auto-load whenever both clinic and purpose are selected (no manual "Load").
  useEffect(() => {
    refresh();
  }, [refresh]);

  const create = useCallback(async (payload) => {
    try {
      await createScenario({ ...payload, clinic_id: clinicId, purpose });
      await refresh();
      return true;
    } catch (e) { setError(e.message); return false; }
  }, [clinicId, purpose, refresh]);

  const update = useCallback(async (id, payload) => {
    try {
      await updateScenario(id, payload);
      await refresh();
      return true;
    } catch (e) { setError(e.message); return false; }
  }, [refresh]);

  const remove = useCallback(async (id) => {
    try {
      await deleteScenario(id);
      await refresh();
      return true;
    } catch (e) { setError(e.message); return false; }
  }, [refresh]);

  const regenerate = useCallback(async () => {
    try {
      await regenerateScenarios({ clinicId, purpose });
      await refresh();
      return true;
    } catch (e) { setError(e.message); return false; }
  }, [clinicId, purpose, refresh]);

  return {
    scenarios, loading, error, clearError,
    clinicId, setClinicId, purpose, setPurpose,
    refresh, create, update, remove, regenerate,
  };
}
